import reducer, { FullArchiveDownloadSubdivState } from "./reducers";
import * as fullArchiveDownloadSubdivOperations from "./operations";
export {
  fullArchiveDownloadSubdivOperations,
  FullArchiveDownloadSubdivState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/fullArchiveDownloadSubdiv/index.ts